import { abbrNumberFilter, decimalNumberFilter } from "app/filters/ngFilters";

export const MIN_VOLUME_VALUE = 1;
export const MIN_SHARE_VALUE = 0.0001;

export const getVolumeValue = (value: number | null | undefined) => Math.max(value || 0, MIN_VOLUME_VALUE);
export const getShareValue = (value: number) => Math.max(value, MIN_SHARE_VALUE);

const isFraction = (value: number): boolean => value > 0 && value < 1;

const isLessThanThousands = (value: number): boolean => {
    return value > 0 && value < 1000;
};

export const normalizeForMinValue = (value: number) =>
    isFraction(value) ? getShareValue(value) : getVolumeValue(value);

export const getUrlSpend = (urlSpend: number) =>
    !!urlSpend &&
    (isLessThanThousands(urlSpend) ? decimalNumberFilter()(urlSpend, true) : abbrNumberFilter()(urlSpend));

export const calculateChangeFromLastMonth = ({
    previousMonthValue,
    currentMonthValue,
}: {
    previousMonthValue: number;
    currentMonthValue: number;
}) => {
    if (previousMonthValue === 0 && currentMonthValue > 0) {
        return -100;
    }
    if (previousMonthValue === 0 && currentMonthValue === 0) {
        return 0;
    }
    return ((currentMonthValue - previousMonthValue) / previousMonthValue) * 100;
};
